import { ReactNode, useCallback } from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { sp } from '@/theme/mui';

import { Icons } from '@/components/atoms/Icon/icons';
import { Icon } from '@/components/atoms/Icon/Icon';
import { NavLink, NavLinkProps } from '@/components/atoms/NavLink/NavLink';

import { CardContainer } from '@/components/templates/CardContainer/CardContainer';

interface ContentItemProps {
  icon?: Icons;
  iconSize?: 'xs' | '1x' | '2x';
  iconType?: 'fas' | 'fal';
  iconColor?: any;
  title?: string;
  description?: string | ReactNode;
  linksTitle?: string;
  links?: NavLinkProps[];
  isPaddingSm?: boolean;
}
const ContentItem = ({
  icon,
  iconSize = '2x',
  iconType,
  title,
  iconColor = 'green',
  description,
  linksTitle,
  links,
  isPaddingSm,
}: ContentItemProps) => {
  return (
    <Stack direction='row' sx={{ gap: isPaddingSm ? sp[2] : sp[16] }}>
      {icon && (
        <Box sx={{ width: iconSize !== '2x' ? sp[24] : sp[48] }}>
          {icon && (
            <Icon
              icon={icon}
              type={iconType}
              size={iconSize}
              color={iconColor}
            />
          )}
        </Box>
      )}
      <Stack sx={{ flex: 1, gap: sp[4], color: '#000000' }}>
        {title && (
          <div>
            <strong>{title}</strong>
          </div>
        )}
        <div>
          {description && (
            <>
              {description}
              <br />
            </>
          )}
          {description && linksTitle && <br />}
          {linksTitle && (
            <>
              {linksTitle}
              <br />
            </>
          )}
          {links?.map((link: any) => (
            <NavLink key={link.href} {...link} />
          ))}
        </div>
      </Stack>
    </Stack>
  );
};

interface ContentProps {
  items?: ContentItemProps[];
  maxColumns?: number;
  size?: 'sm' | 'md';
}
export const InnerContent = ({
  items,
  maxColumns = 1,
  size = 'md',
}: ContentProps) => {
  const Wrapper = useCallback(
    ({ children }: { children?: ReactNode }) => {
      return maxColumns === 1 ? (
        <>{children}</>
      ) : (
        <CardContainer maxColumns={maxColumns}>{children}</CardContainer>
      );
    },
    [maxColumns],
  );
  return (
    <Stack
      sx={{
        p: sp[8],
        typography: 'bodyMd',
        gap: size === 'md' ? sp[24] : sp[16],
      }}
    >
      <Wrapper>
        {items?.map((item, index) => {
          return <ContentItem key={index} {...item} />;
        })}
      </Wrapper>
    </Stack>
  );
};
